// extracted by mini-css-extract-plugin
export default {"shared":"Publish__shared--1OZrZ"};